import { Component, Vue } from 'vue-property-decorator';

// 列表头部的条件
@Component({ name: 'HeaderCol' })
export default class extends Vue {

}
